import { AIConfigModalProvider } from '@dc-shared-web/components/features/AIConfigDialog/types'

export const getModels = (id: string, providers: AIConfigModalProvider[]) => {
  return providers.find((provider) => provider.id === id)?.models ?? []
}
